<template>
  <div class="exportBaseBase">
    <Alert>导出工具箱</Alert>
    <Alert type="success">第一步：选择业务模块</Alert>
    <div class="search-box">
        <div class="left">
            <div class="top-content base-content" >
                <div class="item">
                    <div class="label" >业务模块:</div>
                    <div class="value">
                        <Select  v-model="currentYwmk" placeholder="请选择..." @on-change="generateParam">
                            <Option v-for="item in ['收房-已收房源','收房-收房确认','收房-收房付款','出房-待出租','出房-待提交合同','出房-出房确认','出房-已出房源','出房-出房收款','出房-收款审核-付款明细记录','出房-收款审核-未完成收款']" :key="item" :value="item">{{item}}</Option> 
                        </Select>
                    </div>
                </div>
               
               
            </div>
        

        </div>
         
    </div> 
    <Alert type="success">第二步：设置筛选条件</Alert>
    <div class="search-box" v-show="currentYwmk!=null">
        <div class="left">
            <div class="top-content base-content" >
                <div class="item"  v-for="(selectItem,index) in currentSelectList" :key="selectItem.label+index">
                    <template v-if="selectItem.type=='select'">
                        <div class="label" >{{ selectItem.label }}:</div>
                        <div class="value" v-if="selectItem.alias!=null&&selectItem.alias!=undefined">
                            <Select clearable filterable v-model="params[selectItem.alias]" placeholder="请选择..." @on-change="init" style="width: 100%;">
                                <Option v-for="item in selectItem.selectList" :key="item" :value="item.value">{{item.label}}</Option> 
                            </Select>
                        </div>
                        <div class="value" v-else>
                            <Select clearable filterable v-model="params[selectItem.label]" placeholder="请选择..." @on-change="init" style="width: 100%;">
                                <Option v-for="item in selectItem.selectList" :key="item" :value="item.value">{{item.label}}</Option> 
                            </Select>
                        </div>
                    </template>
                    <template v-if="selectItem.type=='mutipleSelect'">
                        <div class="label" >{{ selectItem.label }}:</div>
                        <div class="value">
                            <Select multiple  clearable filterable v-model="params[selectItem.label]" placeholder="请选择..." @on-change="init" style="width: 100%;">
                                <Option v-for="item in selectItem.selectList" :key="item" :value="item.value">{{item.label}}</Option> 
                            </Select>
                        </div>
                    </template>
                    <template v-else-if="selectItem.type=='daterange'">
                        <div class="label" >{{ selectItem.label }}:</div>
                        <div class="value">
                            <DatePicker format="yyyy-MM-dd" v-model="params[selectItem.label]" type="daterange" placement="bottom-end" placeholder="请选择时间范围" style="width: 100%;" @on-change="(date) => changeDate(date, selectItem.label)"  />
                        </div>
                    </template>
                    <template v-else-if="selectItem.type=='input'">
                        <div class="label" >{{ selectItem.label }}:</div>
                        <div class="value">
                            <Input v-model="params[selectItem.label]" @on-change="init" placeholder="请输入..." style="width: 100%;" />
                        </div>
                    </template>
                    <template v-else-if="selectItem.type=='inputDisabled'">
                        <div class="label" >{{ selectItem.label }}:</div>
                        <div class="value">
                            <Input :disabled="true" v-model="params[selectItem.label]" @on-change="init" placeholder="请输入..." style="width: 100%;" />
                        </div>
                    </template>
                </div>
                <div class="item-button">
                    <Button type="success" :disabled="exportData.length<=0"   icon="md-code-download"    @click="exportBefore" class="btn">导出</Button>   
                </div>

                <!-- <div class="item-button">
                    <Button type="infoinfo" :disabled="exportData.length<=0"   icon="md-code-download"    @click="exportBefore_all" class="btn">导出全部</Button>   
                </div> -->
               
               
            </div>
        

        </div>
         
    </div> 
    <Alert type="success">第三步：核对数据并点击导出按钮</Alert>
    <div class="data-box">
         <Table  border :columns="tableColumns" :data="tableData" @on-selection-change="selectData" class="table-class" :style="{'margin-left':screenWidth*0.01+'px'}" :width="screenWidth*0.98" :height="screenHeight*0.5">
            <template #action="{ row, index } " >
                <div class="buttomGroup">
                    <div class="btn ck" @click="watchDetail(row)">查看</div>  
                </div>
            </template>
         </Table>
        <div class="page-line">
            <Page :total="pageSetting.total" :page-size="pageSetting.pageSize" @on-page-size-change="pageSizeChange"
            @on-change="pageChange" show-elevator show-sizer show-total :page-size-opts="[10, 20,30,40, 50, 100, 200, 500, 1000]" ></Page>
        </div>
      
    </div>
   
     
    <detail-modal ref="detail" :house-detail="houseDetail" :key-list="keyList" :photo-key-list="photoKeyList" :other-key-list="otherKeyList" ></detail-modal>
   

  </div>
</template>

<script>
  import {zfglMethod_2_001} from "@/api/2租房管理/2_001_cxfy.js";
  import detailModal from '@/views/bggl/components/999工具箱/gjxModal/base_detail_modal.vue'
  import { utilTools } from "@/utils/js/utilTools";
import { TableColumn } from "iview";
export default {
  name:"topUser",
  components:{detailModal},
  created(){
        // this.initializeData()
        // console.log("screenWidth==",screenWidth)
        // this.init()
        this.generateParam()


    },
    computed: {
        screenWidth() {
            return this.$screenWidth;
        },
        screenHeight() {
            return this.$screenHeight;
        },
    },
    data() {
        return {
     
            params:{
                dz:"",//房屋地址
                sfr:"",//收房人
                sfmd:"",//收房门店
                ywzt:"",//业务状态
                htqzsj:null,//合同起止时间
                htStart:"",htEnd:"",//拆分为start和end时间
              
            },
            whereParam:[],

            columns:[
                // {title: '序号', type: 'index', width: 60, align: 'center'},
                {title: '房屋地址', key: 'houseAddress', width: 300, align: 'center',fixed:"left"},
                {title: '户型', key: 'houseType', width: 200, align: 'center'},
                {title: '面积(平米)', key: 'area', width: 200, align: 'center'},
                {title: '收房租金(元/月)', key: 'receivingRent', width: 200, align: 'center'},
                {title: '出房指导价(元)', key: 'rentalGuidePrice', width: 200, align: 'center'},
                {title: '物业费(元/月)', key: 'strataFees', width: 200, align: 'center'},
                {title: '合同起始日', key: 'contractStartDate', width: 200, align: 'center'},
                {title: '合同到期日', key: 'contractEndDate', width: 200, align: 'center'},
                {title: '收房人', key: 'receiver', width: 150, align: 'center'},
                {title: '收房门店', key: 'receivingStore', width: 200, align: 'center'},
                {title: '业务状态', key: 'businessStatus', width: 200, align: 'center'},
                {title: '操作', slot: 'action', width: 120, align: 'center',fixed:"right"},

            ],
            keyList:[
                "共", "卫", "厅", "户型", "押金",
                "朝向", "气卡", "水卡", "用途", "电卡",
                "合同ID", "房源ID", "丘权号", "免租期", "可整租",
                "开户行", "收房人", "上架时间", "业务状态", "创建时间",
                "到期预警", "剩余房间", "合同状态",
                "合同编号",  "小区名称", "房东姓名", "房东电话",
                "房东编号", "房屋地址", "所在小区", "支付周期", "支付户名",
                "收房渠道", "收房费用", "收房门店", "楼层信息", "物业费元",
                "空置天数", "装修天数", "装修状态", "送达地址", "配套设施",
                "银行卡号", "不动产权号", "免租期备注", "出房指导价",
                "合同到期日", "合同起始日", "小程序状态", "待租空置期", "总空置天数",
                "收房指导价", "电卡用户名", "维修空置期", "缴费卡信息", "装修空置期",
                "免租期（天）", "收房违约收入", "面积（平米）", "收房租金（元/月）", "第三年免租期（天）",
                "第二年免租期（天）",
               
                ],
            photoKeyList:[ "客厅照片","卧室照片", "厨房照片", "卫生间照片","其他照片",],
            otherKeyList:[
                "其他卡", "套内建筑面积", "出租部位", "是否更换收房人", "委托人电话",
                "街道办", "备注2", "楼号", "建成年代", "是否开通燃气",
                "指导月租金", "出租间套数", "业务序号",  "出租方式",
                "是否可同步", "钥匙/密码", "权属证明编号", "院门牌号", "首页推荐",
                "封面照片", "接收状态", "其他照片", "备注",
                "装修标准", "出租用途", "特别约定", "授权委托书", 
                "房源标签", "中止日期", "装修后照片", "业务员编号", "房屋原貌",
                "坐落", "房源分类", "房源简介", "装修图片", "装修视频",
                "离职分配", "室号", "房源类型", "说明", "权属证明名称",
                "地铁线", "受托代理人姓名", "路街巷", "合同中止时间", "临街状态",
                "产权人身份证号", "交房日期", "产权性质", "公示坐落", "不动产单元号",
                "房源标题", "中止原因"
            ],
            //单独拿出来
            //房屋托管合同信息  产证信息 身份证信息

            pageSetting:{
                pageSize: 15,
                pageIndex: 1,
                total: 0
            },
            houseList:[

            ],
            houseDetail:{},//单个房源详情

            currentYwmk:"收房-已收房源",//业务模块
            currentSelectList:[],//当前筛选
           
            selectList:[
                {selectName:"收房-已收房源",
                    data:[
                        {label:"房屋地址",type:"input",default:""},{label:"合同编号",type:"input",default:"",valueType:"String"},
                        {label:"支付周期",type:"select",default:"",valueType:"String",
                        selectList:[
                            {label:"按半年",value:"按半年"}, {label:"按季",value:"按季"}, {label:"按全年",value:"按全年"}, {label:"按月",value:"按月"},
                        ]},
                        {label:"收房门店",type:"select",default:"",valueType:"String",
                        selectList:[
                            {label:"长白街店",value:"长白街店"}, {label:"福建路店",value:"福建路店"}, {label:"汉中门店",value:"汉中门店"}, {label:"西家大塘",value:"西家大塘"},
                            {label:"运营部",value:"运营部"},
                        ]},
                        {label:"收房人",type:"select",default:"",valueType:"String",
                        selectList:[
                            {label:"陈强",value:"陈强"}, {label:"李新伟",value:"李新伟"}, {label:"李咏枫",value:"李咏枫"}, {label:"吕德婷",value:"吕德婷"},
                            {label:"钱孝珊",value:"钱孝珊"}, {label:"尚海文",value:"尚海文"}, {label:"苏占占",value:"苏占占"}, {label:"孙强",value:"孙强"},
                            {label:"王子鸣",value:"王子鸣"}, {label:"魏琳",value:"魏琳"}, {label:"魏小惠",value:"魏小惠"}, {label:"余奂奂",value:"余奂奂"},
                            {label:"张嵛越",value:"张嵛越"}, {label:"褚朝杰",value:"褚朝杰"},
                        ]},
                        {label:"业务状态",type:"select",default:"",valueType:"String",
                        selectList:[
                            {label:"待出租",value:"待出租"}, {label:"待确认",value:"待确认"}, {label:"未提交",value:"未提交"}, {label:"已出租",value:"已出租"},
                            {label:"已中止",value:"已中止"}, {label:"装修中",value:"装修中"}, {label:"自用房",value:"自用房"},
                        ]},
                        {label:"所在区",type:"select",default:"",valueType:"String",
                        selectList:[
                            {label:"白下区",value:"白下区"}, {label:"鼓楼区",value:"鼓楼区"}, {label:"建邺区",value:"建邺区"}, {label:"江宁区",value:"江宁区"},
                            {label:"老下关",value:"老下关"}, {label:"栖霞区",value:"栖霞区"}, {label:"秦淮区",value:"秦淮区"}, {label:"玄武区",value:"玄武区"},
                            {label:"雨花台区",value:"雨花台区"}, 
                            
                        ]},
                        {label:"中止原因",type:"select",default:"",valueType:"String",
                        selectList:[
                            {label:"到期",value:"到期"}, {label:"违约",value:"违约"},  
                        ]},
                        {label:"离职分配",type:"select",default:"",valueType:"String",
                        selectList:[
                            {label:"离职分配",value:"离职分配"},
                        ]},
                        {label:"合同起始日",type:"daterange",default:[],valueType:"arrayString",},{label:"合同到期日",type:"daterange",default:[],valueType:"arrayString",},
                        
                    ]
                },
                {selectName:"收房-收房确认",
                    data:[
                        {label:"房屋地址",type:"input",default:""},
                        {label:"业务状态",type:"select",default:"待确认",valueType:"String",
                        selectList:[
                            {label:"待出租",value:"待出租"}, {label:"待确认",value:"待确认"}, {label:"未提交",value:"未提交"}, {label:"已出租",value:"已出租"},
                            {label:"已中止",value:"已中止"}, {label:"装修中",value:"装修中"}, {label:"自用房",value:"自用房"},
                        ]},
                        {label:"收房人",type:"select",default:"",valueType:"String",
                        selectList:[
                            {label:"陈强",value:"陈强"}, {label:"李新伟",value:"李新伟"}, {label:"李咏枫",value:"李咏枫"}, {label:"吕德婷",value:"吕德婷"},
                            {label:"钱孝珊",value:"钱孝珊"}, {label:"尚海文",value:"尚海文"}, {label:"苏占占",value:"苏占占"}, {label:"孙强",value:"孙强"},
                            {label:"王子鸣",value:"王子鸣"}, {label:"魏琳",value:"魏琳"}, {label:"魏小惠",value:"魏小惠"}, {label:"余奂奂",value:"余奂奂"},
                            {label:"张嵛越",value:"张嵛越"}, {label:"褚朝杰",value:"褚朝杰"},
                        ]},
                        {label:"是否更换收房人",type:"select",default:"",valueType:"String",
                        selectList:[
                            {label:"是",value:"是"}, {label:"否",value:"否"},
                        ]},
                        
                    ]
                },
                {selectName:"收房-收房付款",
                    data:[
                        {label:"房屋地址",type:"input",default:""},
                        {label:"状态",type:"select",default:"待付",valueType:"String",
                        selectList:[
                            {label:"待付",value:"待付"}, {label:"已付",value:"已付"}, {label:"已中止",value:"已中止"}, 
                        ]},
                        {label:"付款日期",type:"daterange",default:[],valueType:"arrayString",},
                    ]
                },
                {selectName:"出房-待出租",
                    data:[
                        {label:"房屋地址",type:"input",default:""},
                        {label:"收房门店",type:"select",default:"",valueType:"String",
                        selectList:[
                            {label:"长白街店",value:"长白街店"}, {label:"福建路店",value:"福建路店"}, {label:"汉中门店",value:"汉中门店"}, {label:"西家大塘",value:"西家大塘"},
                            {label:"运营部",value:"运营部"},
                        ]},
                        {label:"收房人",type:"select",default:"",valueType:"String",
                        selectList:[
                            {label:"陈强",value:"陈强"}, {label:"李新伟",value:"李新伟"}, {label:"李咏枫",value:"李咏枫"}, {label:"吕德婷",value:"吕德婷"},
                            {label:"钱孝珊",value:"钱孝珊"}, {label:"尚海文",value:"尚海文"}, {label:"苏占占",value:"苏占占"}, {label:"孙强",value:"孙强"},
                            {label:"王子鸣",value:"王子鸣"}, {label:"魏琳",value:"魏琳"}, {label:"魏小惠",value:"魏小惠"}, {label:"余奂奂",value:"余奂奂"},
                            {label:"张嵛越",value:"张嵛越"}, {label:"褚朝杰",value:"褚朝杰"},
                        ]},
                        {label:"所在区",type:"select",default:"",valueType:"String",
                        selectList:[
                             {label:"白下区",value:"白下区"}, {label:"鼓楼区",value:"鼓楼区"}, {label:"建邺区",value:"建邺区"}, {label:"江宁区",value:"江宁区"},
                            {label:"老下关",value:"老下关"}, {label:"栖霞区",value:"栖霞区"}, {label:"秦淮区",value:"秦淮区"}, {label:"玄武区",value:"玄武区"},
                            {label:"雨花台区",value:"雨花台区"}, 
                            
                        ]},
                        {label:"户型",type:"select",default:"",valueType:"String",
                        selectList:[
                            {label:"1室",value:"1室"}, {label:"2室",value:"2室"}, {label:"3室",value:"3室"},   {label:"4室",value:"4室"},
                            {label:"5室",value:"5室"}, {label:"6室",value:"6室"}, {label:"7室",value:"7室"},   {label:"8室",value:"8室"},
                        ]},
                        {label:"业务状态",type:"inputDisabled",default:"待出租"},
                        
                    ]
                },
                {selectName:"出房-待提交合同",
                    data:[
                        {label:"房屋地址",type:"input",default:""},
                        {label:"业务状态",type:"mutipleSelect",default:['未提交','已预定'],valueType:"arrayString",
                        selectList:[
                            {label:"待确认",value:"待确认"}, {label:"已预定",value:"已预定"}, {label:"已出租",value:"已出租"}, 
                            {label:"已取消",value:"已取消"}, {label:"已到期",value:"已到期"}, {label:"已中止",value:"已中止"}, 
                            {label:"未提交",value:"未提交"},
                        ]},
                       
                    ]
                },
                {selectName:"出房-出房确认",
                    data:[
                        {label:"房屋地址",type:"input",default:""},
                        {label:"业务状态",type:"select",default:'待确认',valueType:"string",
                        selectList:[
                            {label:"待确认",value:"待确认"},  {label:"已出租",value:"已出租"}, {label:"已到期",value:"已到期"},
                            {label:"已取消",value:"已取消"}, {label:"已预定",value:"已预定"}, {label:"已中止",value:"已中止"}, 
                            {label:"未提交",value:"未提交"},
                        ]},
                        {label:"是否更换收房人",type:"select",default:"",valueType:"String",
                        selectList:[
                            {label:"是",value:"是"}, {label:"否",value:"否"},
                        ]},
                        {label:"是否更换出房人",type:"select",default:"",valueType:"String",
                        selectList:[
                            {label:"是",value:"是"}, {label:"否",value:"否"},
                        ]},
                        {label:"出房人",type:"select",default:"",valueType:"String",
                        selectList:[
                            {label:"曹剑龙",value:"曹剑龙"}, {label:"陈强",value:"陈强"}, {label:"陈希",value:"陈希"}, {label:"韩彬",value:"韩彬"},
                            {label:"李佳梦",value:"李佳梦"}, {label:"李新伟",value:"李新伟"}, {label:"李咏枫",value:"李咏枫"}, {label:"吕德婷",value:"吕德婷"},
                            {label:"茅鸣先",value:"茅鸣先"}, {label:"钱孝珊",value:"钱孝珊"}, {label:"尚海文",value:"尚海文"}, {label:"苏占占",value:"苏占占"},
                            {label:"孙强",value:"孙强"}, {label:"王艳天",value:"王艳天"},{label:"王子鸣",value:"王子鸣"},{label:"魏琳",value:"魏琳"},
                            {label:"魏士清",value:"魏士清"},{label:"魏小惠",value:"魏小惠"},{label:"夏受品",value:"夏受品"},{label:"杨彦涛",value:"杨彦涛"},
                            {label:"殷佳仪",value:"殷佳仪"},{label:"于奂奂",value:"于奂奂"},{label:"张薛义",value:"张薛义"},{label:"张嵛越",value:"张嵛越"},
                            {label:"郑疏桐",value:"郑疏桐"},{label:"周康",value:"周康"},{label:"周鹏",value:"周鹏"},{label:"褚朝杰",value:"褚朝杰"},
                        ]},
                    ]
                },
                {selectName:"出房-已出房源",
                    data:[
                        {label:"房屋地址",type:"input",default:""},{label:"合同编号",type:"input",default:"",valueType:"String"},
                        {label:"出房门店",type:"select",default:"",valueType:"String",
                        selectList:[
                            {label:"长白街店",value:"长白街店"}, {label:"福建路店",value:"福建路店"}, {label:"汉中门店",value:"汉中门店"}, {label:"西家大塘",value:"西家大塘"},
                            {label:"运营部",value:"运营部"}, {label:"珠江路店",value:"珠江路店"},
                        ]},
                        {label:"出房人",type:"select",default:"",valueType:"String",
                        selectList:[
                            {label:"曹剑龙",value:"曹剑龙"}, {label:"陈强",value:"陈强"}, {label:"陈希",value:"陈希"}, {label:"韩彬",value:"韩彬"},
                            {label:"李佳梦",value:"李佳梦"}, {label:"李新伟",value:"李新伟"}, {label:"李咏枫",value:"李咏枫"}, {label:"吕德婷",value:"吕德婷"},
                            {label:"茅鸣先",value:"茅鸣先"}, {label:"钱孝珊",value:"钱孝珊"}, {label:"尚海文",value:"尚海文"}, {label:"苏占占",value:"苏占占"},
                            {label:"孙强",value:"孙强"}, {label:"王艳天",value:"王艳天"},{label:"王子鸣",value:"王子鸣"},{label:"魏琳",value:"魏琳"},
                            {label:"魏士清",value:"魏士清"},{label:"魏小惠",value:"魏小惠"},{label:"夏受品",value:"夏受品"},{label:"杨彦涛",value:"杨彦涛"},
                            {label:"殷佳仪",value:"殷佳仪"},{label:"于奂奂",value:"于奂奂"},{label:"张薛义",value:"张薛义"},{label:"张嵛越",value:"张嵛越"},
                            {label:"郑疏桐",value:"郑疏桐"},{label:"周康",value:"周康"},{label:"周鹏",value:"周鹏"},{label:"褚朝杰",value:"褚朝杰"},
                        ]},
                        {label:"业务状态",type:"select",default:'已出租',valueType:"string",
                        selectList:[
                            {label:"待确认",value:"待确认"},  {label:"已出租",value:"已出租"}, {label:"已到期",value:"已到期"},
                            {label:"已取消",value:"已取消"}, {label:"已预定",value:"已预定"}, {label:"已中止",value:"已中止"}, 
                            {label:"未提交",value:"未提交"},
                        ]},
                        {label:"所在区",type:"select",default:"",valueType:"String",alias:"房屋",
                        selectList:[
                            {label:"白下区",value:"白下区"}, {label:"鼓楼区",value:"鼓楼区"}, {label:"建邺区",value:"建邺区"}, {label:"江宁区",value:"江宁区"},
                            {label:"老下关",value:"老下关"}, {label:"栖霞区",value:"栖霞区"}, {label:"秦淮区",value:"秦淮区"}, {label:"玄武区",value:"玄武区"},
                            {label:"雨花台区",value:"雨花台区"}, 
                            
                        ]},
                        {label:"标签",type:"select",default:"",valueType:"String",
                        selectList:[
                            {label:"1",value:"1"}, {label:"已到期",value:"已到期"},
                        ]},
                        {label:"是否更换出房人",type:"select",default:"",valueType:"String",
                        selectList:[
                            {label:"是",value:"是"}, {label:"否",value:"否"},
                        ]},
                        {label:"是否续租",type:"select",default:"",valueType:"String",
                        selectList:[
                            {label:"是",value:"是"}, {label:"否",value:"否"},{label:"未续租",value:"未续租"}, {label:"已续租",value:"否已续租"},
                        ]},
                        {label:"合同起始日",type:"daterange",default:[],valueType:"arrayString",},{label:"合同到期日",type:"daterange",default:[],valueType:"arrayString",},
                       
                    ]
                },
                {selectName:"出房-出房收款",
                    data:[
                        {label:"房屋地址",type:"input",default:""},
                        {label:"状态",type:"mutipleSelect",default:['待收','退回','部分收款'],valueType:"arrayString",
                        selectList:[
                            {label:"部分收款",value:"部分收款"}, {label:"待收",value:"待收"}, {label:"未确认",value:"未确认"}, 
                            {label:"已到期",value:"已到期"}, {label:"已收",value:"已收"}, {label:"已中止",value:"已中止"}, 
                            {label:"已完成",value:"已完成"},{label:"退回",value:"退回"},
                        ]},
                        {label:"出房门店",type:"select",default:"",valueType:"String",
                        selectList:[
                            {label:"长白街店",value:"长白街店"}, {label:"福建路店",value:"福建路店"}, {label:"汉中门店",value:"汉中门店"}, {label:"西家大塘",value:"西家大塘"},
                            {label:"运营部",value:"运营部"}, {label:"珠江路店",value:"珠江路店"},
                        ]},
                        {label:"出房人",type:"select",default:"",valueType:"String",
                        selectList:[
                            {label:"曹剑龙",value:"曹剑龙"}, {label:"陈强",value:"陈强"}, {label:"陈希",value:"陈希"}, {label:"韩彬",value:"韩彬"},
                            {label:"李佳梦",value:"李佳梦"}, {label:"李新伟",value:"李新伟"}, {label:"李咏枫",value:"李咏枫"}, {label:"吕德婷",value:"吕德婷"},
                            {label:"茅鸣先",value:"茅鸣先"}, {label:"钱孝珊",value:"钱孝珊"}, {label:"尚海文",value:"尚海文"}, {label:"苏占占",value:"苏占占"},
                            {label:"孙强",value:"孙强"}, {label:"王艳天",value:"王艳天"},{label:"王子鸣",value:"王子鸣"},{label:"魏琳",value:"魏琳"},
                            {label:"魏士清",value:"魏士清"},{label:"魏小惠",value:"魏小惠"},{label:"夏受品",value:"夏受品"},{label:"杨彦涛",value:"杨彦涛"},
                            {label:"殷佳仪",value:"殷佳仪"},{label:"于奂奂",value:"于奂奂"},{label:"张薛义",value:"张薛义"},{label:"张嵛越",value:"张嵛越"},
                            {label:"郑疏桐",value:"郑疏桐"},{label:"周康",value:"周康"},{label:"周鹏",value:"周鹏"},{label:"褚朝杰",value:"褚朝杰"},
                        ]},
                        {label:"考核年份",type:"select",default:"",valueType:"String",
                        selectList:[
                            {label:"2028年",value:"2028"},
                            {label:"2027年",value:"2027"}, {label:"2026年",value:"2026"}, {label:"2025年",value:"2025"}, {label:"2024年",value:"2024"},
                            {label:"2024年",value:"2024"}, {label:"2022年",value:"2022"}, {label:"2021年",value:"2021"}, {label:"2020年",value:"2020"},
                            {label:"2019年",value:"2019"}, {label:"2018年",value:"2018"}, {label:"2017年",value:"2017"}, {label:"2016年",value:"2016"},
                            {label:"2015年",value:"2015"}, {label:"2014年",value:"2014"},
                        ]},
                        {label:"考核月份",type:"select",default:"",valueType:"String",
                        selectList:[ 
                            {label:"1月",value:"1"}, {label:"2月",value:"2"}, {label:"3月",value:"3"}, {label:"4月",value:"4"},
                            {label:"5月",value:"5"}, {label:"6月",value:"6"}, {label:"7月",value:"7"}, {label:"8月",value:"8"},
                            {label:"9月",value:"9"}, {label:"10月",value:"10"}, {label:"11月",value:"11"}, {label:"12月",value:"12"},
                        ]},
                        {label:"预计收款时间",type:"daterange",default:[],valueType:"arrayString",},{label:"考核时间",type:"daterange",default:[],valueType:"arrayString",},
                       
                    ]
                },
                {selectName:"出房-收款审核-付款明细记录",
                    data:[
                        {label:"房屋地址",type:"input",default:""},
                        {label:"状态",type:"mutipleSelect",default:['待审核'],valueType:"arrayString",
                        selectList:[
                            {label:"待审核",value:"待审核"}, {label:"已审核",value:"已审核"},{label:"退回",value:"退回"},
                        ]},
                        {label:"出房门店",type:"select",default:"",valueType:"String",
                        selectList:[
                            {label:"长白街店",value:"长白街店"}, {label:"福建路店",value:"福建路店"}, {label:"汉中门店",value:"汉中门店"}, {label:"西家大塘",value:"西家大塘"},
                            {label:"运营部",value:"运营部"}, {label:"珠江路店",value:"珠江路店"},{label:"石鼓路店",value:"石鼓路店"},
                        ]},
                        {label:"出房人",type:"select",default:"",valueType:"String",
                        selectList:[
                        { "label": "郑疏桐", "value": "郑疏桐" },{ "label": "魏强", "value": "魏强" },{ "label": "孙强", "value": "孙强" },
                        { "label": "周康", "value": "周康" },{ "label": "魏士清", "value": "魏士清" },{ "label": "王子明", "value": "王子明" },
                        { "label": "韩彬", "value": "韩彬" },{ "label": "于奂奂", "value": "于奂奂" },{ "label": "钱孝珊", "value": "钱孝珊" },
                        { "label": "李新伟", "value": "李新伟" },{ "label": "褚朝杰", "value": "褚朝杰" },{ "label": "尚海文", "value": "尚海文" },
                        { "label": "魏琳", "value": "魏琳" },{ "label": "李佳梦", "value": "李佳梦" },{ "label": "杨彦涛", "value": "杨彦涛" },
                        { "label": "王艳天", "value": "王艳天" },{ "label": "夏受品", "value": "夏受品" },{ "label": "admin", "value": "admin" },
                        { "label": "李咏枫", "value": "李咏枫" },{ "label": "魏小惠", "value": "魏小惠" },{ "label": "张薛义", "value": "张薛义" },
                        { "label": "张嵛越", "value": "张嵛越" },{ "label": "陈强", "value": "陈强" },{ "label": "周鹏", "value": "周鹏" },
                        { "label": "茅鸣先", "value": "茅鸣先" }, { "label": "殷佳仪", "value": "殷佳仪" },{ "label": "曹剑龙", "value": "曹剑龙" },
                        { "label": "吕德婷", "value": "吕德婷" },{ "label": "苏占占", "value": "苏占占" }
                        ]},
                     
                        {label:"预计付款时间",type:"daterange",default:[],valueType:"arrayString",},{label:"收款时间",type:"daterange",default:[],valueType:"arrayString",},
                       
                    ]
                },
                {selectName:"出房-收款审核-未完成收款",
                    data:[
                        {label:"房屋地址",type:"input",default:""},
                        {label:"状态",type:"select",default:"",valueType:"string",
                        selectList:[
                            {label:"未完成",value:"待审核"}, {label:"已完成",value:"已审核"},
                        ]},
                        {label:"预计收款时间",type:"daterange",default:[],valueType:"arrayString",},
                       
                    ]
                },
            ],
            selectSqlList:[
                {
                    selectName:"收房-已收房源",tableName:"房源",
                    selectList:[  { "label": "到期预警", "value": "到期预警" },{ "label": "所在区", "value": "所在小区" },{ "label": "房屋地址", "value": "房屋地址" },
                                { "label": "户型", "value": "户型" },{ "label": "面积（平米）", "value": "面积（平米）" },{ "label": "收房租金（元/月）", "value": "收房租金（元/月）" },
                                { "label": "收房费用", "value": "收房费用" },{ "label": "出房指导价", "value": "出房指导价" },{ "label": "物业费（元/月）", "value": "物业费元" },
                                { "label": "押金", "value": "押金" },{ "label": "第一年免租期", "value": "免租期（天）" },{ "label": "收房渠道", "value": "收房渠道" },
                                { "label": "合同起始日", "value": "合同起始日" },{ "label": "合同到期日", "value": "合同到期日" },{ "label": "收房人", "value": "收房人" },
                                { "label": "收房门店", "value": "收房门店" }, { "label": "业务状态", "value": "业务状态" }, { "label": "装修天数", "value": "装修天数" },
                                { "label": "总空置天数", "value": "总空置天数" },{ "label": "支付周期", "value": "支付周期" },{ "label": "产权人", "value": "房东姓名" },
                                { "label": "合同编号", "value": "合同编号" },{ "label": "中止日期", "value": "中止日期" },{ "label": "离职分配", "value": "离职分配" },
                                { "label": "是否可同步", "value": "是否可同步" },{ "label": "同步状态", "value": "同步状态" },{ "label": "房源ID", "value": "房源ID" }]
                },
                {
                    selectName:"收房-收房确认",tableName:"房源",
                    selectList:[{ "label": "房屋地址", "value": "房屋地址" },{ "label": "房东姓名", "value": "房东姓名" },{ "label": "户型", "value": "户型" },
                                { "label": "面积（平米）", "value": "面积（平米）" },{ "label": "合同编号", "value": "合同编号" },{ "label": "合同起始日", "value": "合同起始日" },
                                { "label": "合同到期日", "value": "合同到期日" },{ "label": "收房租金（元/月）", "value": "收房租金（元/月）" },{ "label": "支付周期", "value": "支付周期" },
                                { "label": "物业费（元/月）", "value": "物业费元" },{ "label": "押金", "value": "押金" },{ "label": "第一年免租期", "value": "免租期（天）" },
                                { "label": "收房渠道", "value": "收房渠道" },{ "label": "收房费用", "value": "收房费用" },{ "label": "出房指导价", "value": "出房指导价" },
                                { "label": "收房人", "value": "收房人" },{ "label": "收房门店", "value": "收房门店" },{ "label": "业务状态", "value": "业务状态" },
                                { "label": "房源ID", "value": "房源ID" }]
                },
                {
                    selectName:"收房-收房付款",tableName:"收房付款计划",
                    selectList:[{ "label": "房东", "value": "房东" },{ "label": "房屋地址", "value": "房屋地址" },{ "label": "合同起始日", "value": "合同起始日" },
                                { "label": "合同到期日", "value": "合同到期日" },{ "label": "预计付款日期", "value": "付款日期" },{ "label": "预计付款金额", "value": "付款金额" },
                                { "label": "支付户名", "value": "支付户名" },{ "label": "银行卡号", "value": "银行卡号" },{ "label": "开户行", "value": "开户行" },
                                { "label": "距离付款还有*天", "value": "距离付款还有*天" },{ "label": "实际付款时间", "value": "实际付款时间" },{ "label": "实际付款金额", "value": "实际付款金额" },
                                { "label": "付款凭证", "value": "付款凭证" },{ "label": "上传", "value": "上传" },{ "label": "状态", "value": "状态" },
                                { "label": "房源ID", "value": "房源ID" }]
                },
                {
                    selectName:"出房-待出租",tableName:"房源",
                    selectList:[{ "label": "到期预警", "value": "到期预警" },{ "label": "所在小区", "value": "所在小区" },{ "label": "房屋地址", "value": "房屋地址" },
                                { "label": "户型", "value": "户型" },
                                { "label": "出房指导价", "value": "出房指导价" },{ "label": "收房租金（元/月）", "value": "收房租金（元/月）" },{ "label": "收房人", "value": "收房人" },
                                { "label": "收房门店", "value": "收房门店" },{ "label": "物业费", "value": "物业费元" },{ "label": "空置天数", "value": "空置天数" },
                                { "label": "上架时间", "value": "上架时间" },{ "label": "朝向", "value": "朝向" },{ "label": "面积（平米）", "value": "面积（平米）" },
                                { "label": "房源ID", "value": "房源ID" }]
                },
                {
                    selectName:"出房-待提交合同",tableName:"出房管理",
                    selectList:[ { "label": "所在区", "value": "房屋" },{ "label": "房屋地址", "value": "房屋地址" }, { "label": "户型", "value": "户型" },
                                { "label": "出房租金（元/月）", "value": "出房租金（元/月）" },{ "label": "出房押金（元）", "value": "出房押金（元）" },{ "label": "成交差价（元/月）", "value": "成交差价（元/月）" },
                                { "label": "出房费用（元）", "value": "出房费用（元）" },{ "label": "租金支付周期", "value": "租金支付周期" },{ "label": "业务状态", "value": "业务状态" },
                                { "label": "中止时间", "value": "退房时间" },{ "label": "空置天数", "value": "空置天数" },{ "label": "出房渠道", "value": "出房渠道" },
                                { "label": "收房人", "value": "收房人" },{ "label": "出房人", "value": "出房人" },{ "label": "出房门店", "value": "出房门店" },
                                { "label": "预定时间", "value": "预定时间" },{ "label": "合同起始日", "value": "合同起始日" },{ "label": "合同到期日", "value": "合同到期日" },
                                { "label": "违约收入", "value": "违约收入" },{ "label": "租客姓名", "value": "租客姓名" },{ "label": "合同编号", "value": "合同编号" },
                                { "label": "标签", "value": "标签" },{ "label": "是否更换出房人", "value": "是否更换出房人" },{ "label": "房源ID", "value": "房源ID" }]
                },
                {
                    selectName:"出房-出房确认",tableName:"出房管理",
                    selectList:[{ "label": "租客姓名", "value": "租客姓名" },{ "label": "房屋地址", "value": "房屋地址" },{ "label": "户型", "value": "户型" },
                                { "label": "合同起始日", "value": "合同起始日" },{ "label": "合同到期日", "value": "合同到期日" },{ "label": "业务状态", "value": "业务状态" },
                                { "label": "装修状态", "value": "装修状态" },{ "label": "出房租金（元/月）", "value": "出房租金（元/月）" },{ "label": "租金支付周期", "value": "租金支付周期" },
                                { "label": "出房押金（元）", "value": "出房押金（元）" },{ "label": "成交差价（元/月）", "value": "成交差价（元/月）" },{ "label": "成交周期（天）", "value": "成交周期（天）" },
                                { "label": "出房渠道", "value": "出房渠道" },{ "label": "出房费用（元）", "value": "出房费用（元）" },{ "label": "出房人", "value": "出房人" },
                                { "label": "出房门店", "value": "出房门店" },{ "label": "违约收入", "value": "违约收入" },{ "label": "是否更换出房人", "value": "是否更换出房人" },
                                { "label": "房源ID", "value": "房源ID" }]
                },
                {
                    selectName:"出房-已出房源",tableName:"出房管理",
                    selectList:[{ "label": "所在区", "value": "房屋" },{ "label": "房屋地址", "value": "房屋地址" },{ "label": "户型", "value": "户型" },
                                { "label": "出房租金（元/月）", "value": "出房租金（元/月）" },{ "label": "出房押金（元）", "value": "出房押金（元）" },{ "label": "成交差价（元/月）", "value": "成交差价（元/月）" },
                                { "label": "出房费用（元）", "value": "出房费用（元）" },{ "label": "租金支付周期", "value": "租金支付周期" },{ "label": "业务状态", "value": "业务状态" },
                                { "label": "中止时间", "value": "退房时间" },{ "label": "空置天数", "value": "空置天数" },{ "label": "出房渠道", "value": "出房渠道" },
                                { "label": "收房人", "value": "收房人" },{ "label": "出房人", "value": "出房人" },{ "label": "出房门店", "value": "出房门店" },
                                { "label": "预定时间", "value": "预定时间" },{ "label": "合同起始日", "value": "合同起始日" },{ "label": "合同到期日", "value": "合同到期日" },
                                { "label": "违约收入", "value": "违约收入" },{ "label": "租客姓名", "value": "租客姓名" },{ "label": "合同编号", "value": "合同编号" },
                                { "label": "标签", "value": "标签" },{ "label": "是否更换出房人", "value": "是否更换出房人" },{ "label": "房源ID", "value": "房源ID" }]
                },
                {
                    selectName:"出房-出房收款",tableName:"出房付款计划",
                    selectList:[{ "label": "状态", "value": "状态" },{ "label": "租客姓名", "value": "租客姓名" },{ "label": "房屋地址", "value": "房屋地址" },
                                { "label": "合同起始日", "value": "合同起始日" },{ "label": "合同到期日", "value": "合同到期日" },{ "label": "预计收款时间", "value": "付款时间" },
                                { "label": "预计收款金额", "value": "付款金额" },{ "label": "已收", "value": "已收" },{ "label": "未收", "value": "未收" },
                                { "label": "出房人", "value": "出房人" },{ "label": "逾期天数", "value": "逾期天数" },{ "label": "考核时间", "value": "考核时间" },
                                { "label": "出房ID", "value": "出房ID" }]
                },
                {
                    selectName:"出房-收款审核-付款明细记录",tableName:"出房付款明细",
                    selectList:[{ "label": "状态", "value": "状态" },{ "label": "租客姓名", "value": "租客姓名" },{ "label": "房屋地址", "value": "房屋地址" },
                                { "label": "合同起始日", "value": "合同起始日" },{ "label": "合同到期日", "value": "合同到期日" },{ "label": "预计收款时间", "value": "付款时间" },
                                { "label": "预计收款金额", "value": "付款金额" },   { "label": "收款时间", "value": "实际收款时间" },   { "label": "收款金额", "value": "实际收款金额" },
                                { "label": "租金", "value": "租金" },
                                { "label": "水电费", "value": "水电费" },{ "label": "宽带费", "value": "宽带费" },{ "label": "押金总额", "value": "押金总额" },
                                { "label": "出房ID", "value": "出房ID" }]
                },
                {
                    selectName:"出房-收款审核-未完成收款",tableName:"出房付款计划",
                    selectList:[{ "label": "状态", "value": "状态" },{ "label": "租客姓名", "value": "租客姓名" },{ "label": "房屋地址", "value": "房屋地址" },
                                { "label": "合同起始日", "value": "合同起始日" },{ "label": "合同到期日", "value": "合同到期日" },{ "label": "预计收款时间", "value": "付款时间" },
                                { "label": "预计收款金额", "value": "付款金额" },{ "label": "已收", "value": "已收" },{ "label": "未收", "value": "未收" },
                                { "label": "逾期天数", "value": "逾期天数" },
                                { "label": "出房ID", "value": "出房ID" }]
                },
                
                
            ],
            orderSqlList:[
            {
                    orderName:"收房-已收房源",
                    orderList:[
                        {name:"合同起始日",type:"desc"}
                    ]
            },
            {
                    orderName:"收房-收房确认",
                    orderList:[
                        {name:"创建时间",type:"desc"}
                    ]
            },
            {
                    orderName:"收房-收房付款",
                    orderList:[
                        {name:"付款日期",type:"asc"}, {name:"合同起始日",type:"asc"},
                    ]
            },
            {
                    orderName:"出房-待出租",
                    orderList:[
                        {name:"上架时间",type:"desc"}
                    ]
            },
            {
                    orderName:"出房-待提交合同",
                    orderList:[
                        {name:"合同起始日",type:"desc"}
                    ]
            },
            {
                    orderName:"出房-出房确认",
                    orderList:[ 
                    ]
            },
            {
                    orderName:"出房-已出房源",
                    orderList:[
                        {name:"合同起始日",type:"desc"}
                    ]
            },
            {
                    orderName:"出房-出房收款",
                    orderList:[
                        {name:"付款时间",type:"asc"}
                    ]
            },
            {
                    orderName:"出房-收款审核-付款明细记录",
                    orderList:[
                        {name:"实际收款时间",type:"desc"}
                    ]
            },
            {
                    orderName:"出房-收款审核-未完成收款",
                    orderList:[
                        {name:"付款时间",type:"desc"}
                    ]
            },
            ],
            tableColumns:[],
            tableData:[],
            exportData:[]

           
        }
    },
    
    mounted(){
       
    },
    watch:{},
    methods:{
        init(){ 
            this.generateSql()
         
        },
        // 生成请求参数
        generateParam(name){
            let currentYwmk
            if(name){
                currentYwmk=name
            }else{
                currentYwmk=this.currentYwmk
            }
           this.currentYwmk=currentYwmk
           console.log("currentYwmk==",currentYwmk)
           console.log("his.selectList.find((i)=>{return i.selectName===currentYwmk})==",this.selectList.find((i)=>{return i.selectName===currentYwmk}))
            let currentSelectList=this.selectList.find((i)=>{return i.selectName===currentYwmk}).data
            this.currentSelectList=currentSelectList
            let params={}
            currentSelectList.forEach((item) => {
                console.log("item.alias==",item.alias)
                params[item.alias?item.alias:item.label] = item.default;
            });
            
            this.params=params
            this.init()
            console.log("params==",this.params)
            console.log("this.currentSelectList==",this.currentSelectList)
            this.generateColumns()

        },
        // 生成表格的列
        generateColumns(){
            console.log("currentYwmk==",currentYwmk)
            let currentYwmk=this.currentYwmk
            let currentSelectSqlList=this.selectSqlList.find((i)=>{return i.selectName===currentYwmk})
            let tableColumns=[]
            tableColumns.push(   { type: 'selection', width: 60,  align: 'center',fixed:"left" })
         
            currentSelectSqlList.selectList.forEach((i,index)=>{
               if(!(i.label.includes("ID"))){
                    if(i.label=="房屋地址"){
                        tableColumns.push(   {title: '房屋地址', key: '房屋地址', width: 300, align: 'center',fixed:"left"},)
                    }else{
                        tableColumns.push( {title: i.label, key: i.label, width: 180, align: 'center'})
                    }
               }
            })
            if(['收房-已收房源','收房-收房确认'].includes(currentYwmk)){
                tableColumns.push(  {title: '操作', slot: 'action', width: 200, align: 'center',fixed:"right"}, )
            }
            
            this.tableColumns=tableColumns

// 
        },
        // 生成sql
        generateSql(){
            let currentYwmk=this.currentYwmk
            let currentSelectSqlList=this.selectSqlList.find((i)=>{return i.selectName===currentYwmk})
            
            let fromParam=currentSelectSqlList.tableName
            let selectParam=``
            currentSelectSqlList.selectList.forEach((i,index)=>{
                if(i.label=="合同起始日"||i.label=="合同到期日"||i.label=="预计收款时间"||i.label=="考核时间"||i.label=="预计付款日期"){
                    selectParam+=index== (currentSelectSqlList.selectList.length-1)?`to_char(to_timestamp(${i.value} / 1000) , 'YYYY-MM-DD')" as "${i.label}"`:`to_char(to_timestamp(${i.value} / 1000) , 'YYYY-MM-DD') as "${i.label}",`
                }else{
                    selectParam+=index== (currentSelectSqlList.selectList.length-1)?`"${i.value}" as "${i.label}"`:`"${i.value}" as "${i.label}",`
                }
               
            })
            let whereParam=""
            for (let [key, value] of Object.entries(this.params)) {
                if(value==""||value==0||value==null||value==[]||value=={}||value==undefined){continue;}
                
                let type=this.currentSelectList.find((i)=>{
                    if(i.alias&&i.alias==key){return i}
                    else{return i.label==key}
                }).type
                if(type=="daterange"){
                    if(value[0]==""||value[0]==null||value[1]==""||value[1]==null){continue;}
                    whereParam+=` 
                      AND  to_char(to_timestamp("${key}" / 1000) , 'YYYY-MM-DD')  BETWEEN '${value[0]}' AND '${value[1]}'
                       
                                `
                            //     AND (
                            //     "${key}"::TEXT ~ '^[0-9]+$' OR  -- 纯数字时间戳
                            //     "${key}"::TEXT ~ '^[0-9]{4}-[0-9]{2}-[0-9]{2} [0-9]{2}:[0-9]{2}:[0-9]{2}$'  -- 完整日期时间格式
                            // )
                            // AND CASE
                            //     WHEN "${key}"::TEXT ~ '^[0-9]+$' THEN
                            //         to_timestamp("${key}"::BIGINT / 1000) 
                            //     WHEN "${key}"::TEXT ~ '^[0-9]{4}-[0-9]{2}-[0-9]{2} [0-9]{2}:[0-9]{2}:[0-9]{2}$' THEN
                            //         "${key}"::TIMESTAMP 
                            //     ELSE NULL
                            // END BETWEEN '${value[0]}'::TIMESTAMP AND '${value[1]}'::TIMESTAMP
                }
                else if(type=="mutipleSelect"){
                      whereParam+=`and "${key}" in (`
                    value.forEach((i,index)=>{
                        whereParam+= index==value.length-1?`'${i}' )`:`'${i}' ,`
                    }) 
                }
                // else if(type=="number"){
                //     whereParam+=`and "${key}" like concat('%','${value}','%')`
                // }
                else{
                    whereParam+=`and "${key}" like concat('%','${value}','%')`
                } 
            }
            let orderParam=""
            let orderList=this.orderSqlList.find((i)=>{return i.orderName==currentYwmk}).orderList
            orderList.forEach((i,index)=>{
                orderParam+=index==(orderList.length-1)?` ${i.name} ${i.type}  `:` ${i.name} ${i.type} ,  `
            })
            let offset = (this.pageSetting.pageIndex - 1) * this.pageSetting.pageSize
            let limitParam=` LIMIT ${this.pageSetting.pageSize} OFFSET ${offset}`

            //  let offset = ""
            // let limitParam="LIMIT 500"
            console.log("selectParam===",selectParam)
            console.log("fromParam===",fromParam)
            console.log("whereParam===",whereParam)
            console.log("orderParam===",orderParam)
            console.log("limitParam===",limitParam)
            this.initFromParam(selectParam,fromParam,whereParam,orderParam,limitParam)


        },
        // 加载数据
        initFromParam(selectParam,fromParam,whereParam,orderParam,limitParam){
            let requestParam={
                selectParam:selectParam,fromParam:fromParam,whereParam:whereParam,orderParam:orderParam,limitParam:limitParam
            }
            zfglMethod_2_001.exportBefore(requestParam).then((res)=>{
                console.log("res===",res)
                if(res.code==200){
                    this.tableData=res.data.list
                    this.pageSetting.total=res.data.count
                }
                console.log("selectRes===",res)
            }) 
        },
        // 查看详情
        watchDetail(row){
            let params={
                id:row['房源ID'],
                table:`"${this.selectSqlList.find((i)=>{return i.selectName===this.currentYwmk}).tableName}"`
            }
            zfglMethod_2_001.operateWahckDetail(params).then((res)=>{
                console.log("detail==res===",res)
                this.houseDetail=res.data 
                this.$refs.detail.detailModal=true
                // this.$nextTick(()=>{
                //     this.$refs.detail.detailModal=true
                // })

            })
        },
        // table选择数据
        selectData(data){
            console.log("data==",data)
            this.exportData=data
        },
        //exportBefore
        exportBefore(){
            //headers, data, fileName, dataHeaders
            // 组装headers
            let headers=[]
            console.log("tableColumn==",this.tableColumns)
            this.tableColumns.forEach((i)=>{
                if(i.title){
                    headers.push(i.title)
                }
            })
            console.log("headers==",headers)
            // 组装data
            let data=JSON.parse(JSON.stringify(this.exportData))

            // data.forEach(())
            utilTools.exportToExcel(headers,data,headers,this.currentYwmk)
        },

        exportBefore_all(){
            let headers=[]
            console.log("tableColumn==",this.tableColumns)
            this.tableColumns.forEach((i)=>{
                if(i.title){
                    headers.push(i.title)
                }
            })
            console.log("headers==",headers)


            
            // 组装data
            let data=JSON.parse(JSON.stringify(this.exportData))

            // data.forEach(())
            utilTools.exportToExcel(headers,data,headers,this.currentYwmk)

        },
        clear(){
            this.params={
                fwdz:"",//房屋地址
                sfr:"",//收房人
                sfmd:"",//收房门店
                ywzt:"",//业务状态
                htqzsj:null,//合同起止时间
                htStart:"",htEnd:"",//拆分为start和end时间
                pageSize:15,
                pageIndex:1,
            }
            this.init()
        },
        pageSizeChange(i) {
            this.pageSetting.pageSize = i;
            this.init()
        },
        pageChange(i) {
            this.pageSetting.pageIndex = i;
            this.init()
        },
        changeDate(date,dataName){
            // console.log("date==",date)
            this.params[dataName]=date
            this.$nextTick(()=>{
                this.init()
            })
        },
   
    }


}
</script>

  
  <style lang="scss" >
@import 'exportBaseBase.scss'; 

  </style>